import { getImageUrl } from "helpers";


const StatisticCardItem = ({ data }) => {
    const { icon,
        title,
        small_title,
        description } = data

    const image = getImageUrl(icon)

    return (
        <div className="statistic-cards-item">
            <div className="statistic-cards-item__icon ">
                <img src={image} alt="" />
            </div>
            <div className={`h2 ${small_title === "+" && "h2--center"}`}>
                {title} {small_title && <span className='description2'>{small_title}</span>}
            </div>
            <div className="body2">
                {description}
            </div>
        </div>
    );
}

export default StatisticCardItem;